"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpandableSection = void 0;
var react_1 = require("react");
var ExpandableSection_style_1 = __importDefault(require("./ExpandableSection.style"));
function useExpandableSection(_a) {
    var initiallyExpanded = _a.initiallyExpanded;
    var _b = __read((0, react_1.useState)(initiallyExpanded), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    return {
        classes: (0, ExpandableSection_style_1.default)(),
        handleTitleClick: function () { return setIsExpanded(function (state) { return !state; }); },
        isExpanded: isExpanded,
    };
}
exports.useExpandableSection = useExpandableSection;
var logic = {
    useExpandableSection: useExpandableSection,
};
exports.default = logic;
